import { Empty_NoSqlDoc, FBDTKeygenGeneric, MakeFBDocType, NoSqlDoc } from '@rabbit/firebase/doctype';
import { TenantLink } from './tenant';

export interface DTApiLog extends NoSqlDoc {
  correlationId: string;
  tenantLink?: TenantLink;
  path: string;
  method: string;
  request: {
    headers: Record<string, any>;
    body: any;
    query?: Record<string, any>;
    params?: Record<string, any>;
  };
  response: {
    statusCode?: number;
    headers?: Record<string, any>;
    body?: any;
  };
  timestamp: number;
}

export const FBD_ApiLog = MakeFBDocType<DTApiLog>({
  name: 'API Log',
  collection: 'api_logs',
  empty: () => {
    const result: DTApiLog = {
      ...Empty_NoSqlDoc(),
      correlationId: '',
      tenantLink: '',
      path: '',
      method: '',
      request: {
        headers: {},
        body: {},
        query: {},
        params: {},
      },
      response: {
        statusCode: 0,
        headers: {},
        body: {},
      },
      timestamp: Date.now(),
    };
    return result;
  },
  keygen: FBDTKeygenGeneric,
});
